export default __webpack_public_path__ + "css/product.bundle.css";